const TENANT_SESSION_KEY = '__typogram_tenant';

/**
 * Build query params for GET /api/public/institutions/branding.
 *
 * - Custom domain (e.g. www.gangajewellers.in): { host: 'www.gangajewellers.in' }
 * - Dev on localhost: ?tenant=subdomain → { subdomain: 'acme' }
 * - Consumer Typogram hosts: null (no tenant banner)
 *
 * Once a tenant is detected (via ?tenant= or custom domain), it is persisted
 * in sessionStorage so it survives React Router navigations and page reloads
 * within the same browser tab.
 */
export function getTenantBrandingParams() {
  if (typeof window === 'undefined') return null;

  const host = window.location.hostname.toLowerCase();
  const tenantQ = new URLSearchParams(window.location.search).get('tenant');

  const consumerHosts = new Set([
    'typogram.in',
    'www.typogram.in',
    'localhost',
    '127.0.0.1',
  ]);

  if (tenantQ && tenantQ.trim()) {
    const sub = tenantQ.trim().toLowerCase();
    try { sessionStorage.setItem(TENANT_SESSION_KEY, sub); } catch {}
    return { subdomain: sub };
  }

  // On consumer hosts, check sessionStorage for a previously set tenant
  if (consumerHosts.has(host)) {
    try {
      const stored = sessionStorage.getItem(TENANT_SESSION_KEY);
      if (stored) return { subdomain: stored };
    } catch {}
    return null;
  }

  return { host };
}

/** @deprecated use getTenantBrandingParams + getBranding */
export function getInstitutionSubdomainFromHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const params = typeof window !== 'undefined' ? getTenantBrandingParams() : null;
  if (params?.subdomain) return params.subdomain;
  const h = String(hostname || '').toLowerCase();
  if (h === 'localhost' || h.startsWith('127.')) {
    if (typeof window === 'undefined') return null;
    const q = new URLSearchParams(window.location.search).get('tenant');
    return q && q.trim() ? q.trim().toLowerCase() : null;
  }
  const parts = h.split('.').filter(Boolean);
  if (parts.length >= 3) {
    const sub = parts[0];
    if (sub === 'www' || sub === 'app') return null;
    return sub;
  }
  return null;
}
